module.exports = "pegasus/assets/square-youtube.png";